import { searchStringApplyingAutoVoidParam } from '../auto-void-modal';

export const onClickAutoVoidEffect = (options = {}) => {
  const { search, history } = options;
  return () => {
    history.replace(searchStringApplyingAutoVoidParam(search));
  };
};
